import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { HelmetProvider } from 'react-helmet-async';
import { registerServiceWorker } from './pwa/registerServiceWorker';

// Capacitor imports
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { Keyboard } from '@capacitor/keyboard';

// Initialize Capacitor plugins when running on mobile
if (Capacitor.isNativePlatform()) {
  // Configure status bar
  // Keep system status bar clearly visible on mobile and avoid overlaying WebView content.
  StatusBar.setOverlaysWebView({ overlay: false }).catch(() => {});
  StatusBar.setBackgroundColor({ color: '#111827' }).catch(() => {});
  StatusBar.setStyle({ style: Style.Light }).catch(() => {});

  // Configure keyboard
  // Not supported on all platforms (e.g. some Android WebView builds)
  Keyboard.setAccessoryBarVisible({ isVisible: true }).catch(() => {});

  // Hide splash screen after app loads
  SplashScreen.hide().catch(() => {});
}

// Register the PWA service worker (web build only - see registerServiceWorker)
registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
);
